import { MiniPDPCollection } from './miniPDPCollection'

export default MiniPDPCollection
